(function(){
  // product form: size radios -> variant id, availability, button label
  document.querySelectorAll('[data-lp-product-form]').forEach(function(form){
    var dataEl = form.querySelector('script[data-lp-variants]');
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-lp-add]');
    var priceEl = document.querySelector('[data-lp-price]');
    function current(){
      var picked = [];
      form.querySelectorAll('fieldset[data-lp-option]').forEach(function(fs){
        var c = fs.querySelector('input:checked'); picked.push(c ? c.value : null);
      });
      return variants.find(function(v){ return v.options.every(function(o,i){ return picked[i] === null || o === picked[i]; }); });
    }
    function update(){
      var v = current();
      if(!v){ btn.disabled = true; btn.textContent = 'unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'add to bag' : 'sold out';
      if(priceEl && v.price_html){ priceEl.innerHTML = v.price_html; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', update);
    update();
  });
  // menu: close on escape
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ document.querySelectorAll('details.lp-menu[open]').forEach(function(d){ d.removeAttribute('open'); }); }
  });
  document.querySelectorAll('[data-lp-close-menu]').forEach(function(b){
    b.addEventListener('click', function(){ var d = b.closest('details'); if(d) d.removeAttribute('open'); });
  });
})();